export const CHANNEL_LINKEDIN = 1
export const CHANNEL_TWITTER = 2
export const CHANNEL_FACEBOOK = 3
export const CHANNEL_BLOG = 4
export const CHANNEL_GITHUB = 10

export enum Channel {
  LinkedIn = CHANNEL_LINKEDIN,
  Twitter = CHANNEL_TWITTER,
  Facebook = CHANNEL_FACEBOOK,
  Github = CHANNEL_GITHUB,
}
